import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { quoteStatus } from '../../data/quoteStatus';
import { ClientContext } from './contexts';

function useFetch() {
  const clientContext = useContext(ClientContext);

  const navigate = useNavigate();

  const shouldRedirect = () => {
    if (clientContext?.redirection?.clientRedirected) return;

    const states = clientContext?.fetchingCurrentState;

    const statesFinished = Object.entries(states).filter(
      ([, value]) => value !== 'finished'
    );

    if (statesFinished.length === 0) {
      const cer = clientContext?.clientExpertRelation;

      // Vérifie si cer est non défini
      if (cer === undefined) {
        // Vérifie si dans les rejetés, il a donné son avis ou pas
        const unsignedCer = clientContext?.clientExpertRelations?.find(
          (clientExpertRel) => clientExpertRel?.clientSigned === 0
        );

        // Si une relation a été trouvé, on redirige le client vers la page des devis acceptés
        if (unsignedCer !== undefined) {
          clientContext?.redirection?.setClientRedirected(true);
          navigate('/accepted-quotes');
          return;
        }

        // Vérifie si une relation a le statut "en cours d'investigation"
        const investigatedCer = clientContext?.clientExpertRelations?.find(
          (clientExpertRel) =>
            clientExpertRel?.status === quoteStatus.investigation
        );

        // Si une relation a le statut "investigation", on redirige vers la page des devis acceptés
        if (investigatedCer !== undefined) {
          clientContext?.redirection?.setClientRedirected(true);
          navigate('/accepted-quotes');
          return;
        }

        clientContext?.redirection?.setClientRedirected(true);
        navigate('/quotes');
        return;
      } else {
        if (
          [
            quoteStatus.clientChoseExpert,
            quoteStatus.expertAcceptClient,
          ].includes(cer?.status)
        ) {
          // redirect into waiting acceptation
          clientContext?.redirection?.setClientRedirected(true);
          navigate('/waiting-acceptations');
          return;
        } else {
          clientContext?.redirection?.setClientRedirected(true);
          navigate('/accepted-quotes');
          return;
        }
      }
    }
  };

  return { shouldRedirect };
}

export default useFetch;
